import React from 'react';
import { Helmet } from 'react-helmet';
import assetUrl from '../utils/assetUrl';
import Navigation from './Universal/Navigation';
import Footer from './Universal/Footer';

const TeamPage = () => {
  const teamMembers = [
    {
      name: 'John Ai',
      title: 'CHIEF EXECUTIVE OFFICER AND CHIEF VEHICLE ENGINEER',
      subtitle: 'Founder and Visionary',
      description: 'John Ai directs Aluren’s hardware engineering with end to end ownership of vehicle architecture, propulsion systems, and manufacturing executions and innovative thinking.',
      image: assetUrl('john-ai-proper-art.png'),
    },
  ];

  return (
    <>
      <Helmet>
        <title>ALUREN DYNAMICS</title>
        <link rel="icon" href="/ALUREN WATERMARK.png" />
      </Helmet>
      <Navigation />
      <section className="team-section" style={{ padding: '40px 20px 60px 20px', backgroundColor: '#000' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: '50px',
            letterSpacing: '0.1em',
            color: 'white',
          }}>
            FOUNDERS
          </h2>

          <div className="team-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 560px)',
            justifyContent: 'center',
            gap: '3rem',
          }}>
            {teamMembers.map((member) => (
              <div
                key={member.name}
                className="team-card"
                style={{
                  borderRadius: '12px',
                  backgroundColor: '#000',
                  border: '0.5px solid #fff',
                  transition: 'all 0.3s ease, border-color 0.3s ease',
                  cursor: 'pointer',
                  textAlign: 'center',
                  overflow: 'hidden',
                }}
                onMouseOver={(event) => {
                  event.currentTarget.style.transform = 'translateY(-5px)';
                  event.currentTarget.style.boxShadow = '0 0 20px rgba(82, 39, 255, 0.6), 0 8px 24px rgba(82, 39, 255, 0.3)';
                  event.currentTarget.style.borderColor = '#5227FF';
                }}
                onMouseOut={(event) => {
                  event.currentTarget.style.transform = 'translateY(0)';
                  event.currentTarget.style.boxShadow = 'none';
                  event.currentTarget.style.borderColor = '#fff';
                }}
              >
                <div className="team-card-image" style={{
                  width: '100%',
                  height: '250px',
                  background: '#fff',
                  position: 'relative',
                  overflow: 'hidden',
                }}>
                  <img
                    src={member.image}
                    alt={member.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      objectPosition: 'center bottom',
                      transform: 'scale(0.8925)',
                      pointerEvents: 'none',
                      background: '#fff',
                    }}
                  />
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: '20%',
                    background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.1) 20%, rgba(0,0,0,0.5) 60%, #000 90%)',
                    pointerEvents: 'none',
                    zIndex: 1,
                  }} />
                </div>
                <div className="team-card-body" style={{ padding: '0 2rem 2rem 2rem', position: 'relative', zIndex: 2, background: 'transparent' }}>
                  <h3 className="team-card-name" style={{
                    fontSize: '1.5rem',
                    fontWeight: '700',
                    marginTop: '-0.33rem',
                    marginBottom: '0.5rem',
                    color: 'white',
                  }}>
                    {member.name}
                  </h3>
                  <h4 className="team-card-title" style={{
                    fontSize: '1rem',
                    fontWeight: '300',
                    marginBottom: '0.25rem',
                    color: '#e5e7eb',
                    letterSpacing: '0.05em',
                  }}>
                    {member.title}
                  </h4>
                  <p className="team-card-subtitle" style={{
                    fontSize: '0.9rem',
                    color: '#9ca3af',
                    marginBottom: '1.5rem',
                    fontStyle: 'italic',
                  }}>
                    {member.subtitle}
                  </p>
                  <p className="team-card-description" style={{
                    color: '#9ca3af',
                    lineHeight: '1.6',
                    fontSize: '1rem',
                  }}>
                    {member.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <p style={{
          color: '#9ca3af',
          textAlign: 'center',
          fontSize: '1rem',
          lineHeight: '1.6',
        }}>
          Thank you to everyone who has supported and provided guidance in shaping the future of Aluren.
        </p>
      </section>
      <Footer />
    </>
  );
};

export default TeamPage;
